import React from "react";
import { Box } from "@mui/material";
import StepUpSpinner from "./StepUpSpinner";

/**
 * Branded universal page loader — the single loading UI used across
 * every route-level Suspense fallback AND every page-level "initial
 * data still loading" gate. Full white background so no partly-
 * rendered shell peeks through underneath.
 *
 * a11y: role="status" + aria-live so screen readers announce the load;
 * @media(prefers-reduced-motion) is respected by the individual
 * keyframes in StepUpSpinner via the user agent's default handling.
 */
const Loader = () => (
  <Box
    role="status"
    aria-live="polite"
    aria-label="Loading page"
    sx={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      height: "100vh",
      width: "100%",
      bgcolor: "#fff",
    }}
  >
    <StepUpSpinner size="large" label="Loading" />
  </Box>
);

export default Loader;
